export const SEND_STATS_SUCCESS = 'SEND_STATS_SUCCESS';
export const SEND_STATS_FAILURE = 'SEND_STATS_FAILURE';
export const sendStatsSuccess = title => ({
  type: SEND_STATS_SUCCESS,
  payload: title
});
export const sendStatsFailure = error => ({
  type: SEND_STATS_FAILURE,
  payload: error
});